import React, { useEffect, useState, useRef } from 'react'
import { useNavigate } from 'react-router-dom'
// import LanguageSwitcher from './LanguageSwitcher';

const safeDocument = typeof document !== 'undefined' ? document : {};

export default function NavbarHeader() {
    const [isOpen, setIsOpen] = useState(false)
    const navigate = useNavigate()
    const scrollBlocked = useRef();
    const html = safeDocument.documentElement;
    const { body } = safeDocument;

    const blockScroll = () => {
        if (!body || !body.style || scrollBlocked.current) return;

        const scrollBarWidth = window.innerWidth - html.clientWidth;
        const bodyPaddingRight =
            parseInt(window.getComputedStyle(body).getPropertyValue("padding-right")) || 0;

        /**
         * 1. Fixes a bug in iOS and desktop Safari whereby setting
         *    `overflow: hidden` on the html/body does not prevent scrolling.
         * 2. Fixes a bug in desktop Safari where `overflowY` does not prevent
         *    scroll if an `overflow-x` style is also applied to the body.
         */
        html.style.position = 'relative'; /* [1] */
        html.style.overflow = 'hidden'; /* [2] */
        body.style.position = 'relative'; /* [1] */
        body.style.overflow = 'hidden'; /* [2] */
        body.style.paddingRight = `${bodyPaddingRight + scrollBarWidth}px`;

        scrollBlocked.current = true;
    };

    const allowScroll = () => {
        if (!body || !body.style || !scrollBlocked.current) return;

        html.style.position = '';
        html.style.overflow = '';
        body.style.position = '';
        body.style.overflow = '';
        body.style.paddingRight = '';

        scrollBlocked.current = false;
    };

    useEffect(() => {
        if (isOpen) {
            blockScroll()
        } else {
            allowScroll()
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isOpen]);

    return (
        <div style={{ overflow: "hidden" }}>
            <div className='border-primary-bottom' style={{
                width: "100%",
                height: "65px",
                padding: "15px 0"
            }}>
                <div className='container'>
                    <div style={{
                        float: "left"
                    }}>
                        <i
                            className="fa-solid fa-bars"
                            style={{
                                fontSize: "21px",
                                marginTop: "6px"
                            }}
                            onClick={() => {
                                let status = isOpen
                                setIsOpen(!status)
                            }}
                        ></i>
                    </div>
                </div>
            </div>
            {
                isOpen && <div className='sticky-top' style={{
                    display: "block",
                    width: "100%",
                    height: "100vh",
                    background: "rgba(0,0,0,0.2)",
                    color: "#fff",
                    fontSize: "15px",
                    overflow: "hidden"
                }}>
                    <div
                        style={{
                            position: 'relative',
                            width: "220px",
                            height: "100vh",
                            background: "black",
                            borderRight: "2px solid #6495ED",
                        }}
                    >
                        <div style={{
                            padding: "10px 15px",
                            borderBottom: "2px solid #6495ED"
                        }}>
                            <img
                                src="/assets/images/logo.png"
                                alt="logo"
                                style={{
                                    width: "100%",
                                    height: "auto"
                                }}
                                onClick={() => {
                                    navigate("/")
                                    setIsOpen(false)
                                }}
                            />
                        </div>
                        <div style={{
                            padding: "10px 15px",
                            borderBottom: "2px solid #6495ED"
                        }}
                            onClick={() => {
                                navigate("/")
                                setIsOpen(false)
                            }}
                        >
                            <i className="fa-solid fa-house-chimney"></i>&nbsp;&nbsp;จองที่นั่ง
                        </div>
                        <div style={{
                            padding: "10px 15px",
                            borderBottom: "2px solid #6495ED"
                        }}
                            onClick={() => {
                                navigate("/ticket")
                                setIsOpen(false)
                            }}
                        >
                            <i className="fa-solid fa-ticket"></i>&nbsp;&nbsp;ประวัติการใช้งาน
                        </div>
                        <div style={{
                            padding: "10px 15px",
                            borderBottom: "2px solid #6495ED"
                        }}
                            onClick={() => {
                                navigate("/privacy")
                                setIsOpen(false)
                            }}
                        >
                            <i className="fa-solid fa-building-shield"></i>&nbsp;&nbsp;นโยบายความเป็นส่วนตัว
                        </div>
                        {/* <div style={{
                            padding: "10px 15px",
                            borderBottom: "2px solid #6495ED"
                        }}
                        >
                            <LanguageSwitcher setIsOpen={setIsOpen}/>
                        </div> */}
                    </div>
                </div>
            }
        </div >
    )
}
